import { useState } from 'react'
import Spinner from './Spinner'
import styles from './Avatar.module.css'

export type AvatarVariant = 'default' | 'you' | 'leader'
export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

interface AvatarProps {
  initials: string
  photoUrl?: string
  size?: AvatarSize
  variant?: AvatarVariant
  isLoading?: boolean
}

export default function Avatar({
  initials,
  photoUrl,
  size = 'md',
  variant = 'default',
  isLoading,
}: AvatarProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)
  const showPhoto = Boolean(photoUrl && failedUrl !== photoUrl)

  return (
    <span
      className={[styles.avatar, styles[size], variant !== 'default' && styles[variant]]
        .filter(Boolean)
        .join(' ')}
    >
      {showPhoto ? (
        <img
          src={photoUrl}
          alt=""
          className={styles.image}
          onError={() => setFailedUrl(photoUrl ?? null)}
        />
      ) : (
        initials
      )}
      {isLoading && (
        <span className={styles.loading}>
          <Spinner size="sm" />
        </span>
      )}
    </span>
  )
}

export function getInitials(firstName: string, lastName?: string) {
  const first = firstName?.charAt(0) ?? ''
  const last = lastName?.charAt(0) ?? ''
  return `${first}${last}`.toUpperCase()
}
